// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_style_input__27ID-","total_text_right":"Input_style_total_text_right__1LPl0","required":"Input_style_required__u5PNV"};